module.exports = new __parcel__URL__("../SVG/close-line.024d3909.svg").toString();